import React, { createContext, useContext, useState } from 'react';
import { ReactNode } from 'react';
import { SubPatientSubscription, useSubPatientSubscription } from '@/data/data';

type PatientContextType = {
  patient: SubPatientSubscription['patientByPk'];
  loading: boolean;
  setPatientId: (state: string) => void;
};

// Create the context
const PatientContext = createContext<PatientContextType>({
  patient: null,
  setPatientId: () => {},
  loading: false,
});

type PatientProviderProps = {
  children: ReactNode;
};

// Create the provider component
const PatientContextProvider = (props: PatientProviderProps) => {
  const [patientId, setPatientId] = useState('');
  const { children } = props;
  const { loading, data } = useSubPatientSubscription({
    variables: {
      id: patientId,
    },
    skip: patientId === '',
  });

  return (
    <PatientContext.Provider
      value={{
        patient: data?.patientByPk,
        setPatientId,
        loading,
      }}
    >
      {children}
    </PatientContext.Provider>
  );
};

const usePatientContext = () => useContext(PatientContext);

// Export the context and provider
export { PatientContext, PatientContextProvider, usePatientContext };
